import { render, staticRenderFns } from "./BaseCompany.vue?vue&type=template&id=7d56cb79&"
import script from "./BaseCompany.vue?vue&type=script&lang=js&"
export * from "./BaseCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports